<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title class="headline">
        <span>{{ item ? `Edit Manager (${item.name})` : 'New Manager' }}</span>
        <v-spacer></v-spacer>
        <v-icon @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                  v-model="managerData.name"
                  :items="umbrellaUsers"
                  :rules="validationRules.name"
                  label="Umbrella User"
                  placeholder="Select a user"
                  clearable
                  return-object
                  @change="updateEmail"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                  v-model="managerData.status"
                  :items="managerStatus"
                  label="Manager Status"
                  placeholder="Select status"
                  :value="managerData.status"
                  clearable
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                  v-model="managerData.umbrellaRole"
                  label="Umbrella Role"
                  :readonly="true"
                  disabled
                  :value="managerData.umbrellaRole"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                  v-model="managerData.email"
                  :readonly="true"
                  disabled
                  label="Email"
                  placeholder="Enter email address"
                  :value="managerData.email"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                  v-model="managerData.role"
                  :items="managerRoles"
                  label="Manager Role"
                  placeholder="Select role"
                  :value="managerData.role"
                  :rules="validationRules.role"
                  clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                  v-model="managerData.skypeId"
                  label="Skype ID"
                  placeholder="Enter Skype ID"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!isFormValid" color="primary" @click="handleCreateOrUpdateManager">
          {{ item ? 'UPDATE MANAGER' : 'CREATE MANAGER' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import ProgressBar from "@/components/pages/affiliates/customAssets/ProgressBar.vue";

export default {
  components: {ProgressBar},
  props: {
    item:{},
    value: Boolean,
  },
  data() {
    return {
      isUploading: false,
      isEdit: false,
      umbrellaUsers: [],
      umbrellaUsersAll: [],
      managerRoles: ['BA','BD'],
      managerStatus: ['active','inactive'],
      isValidImage: true,
      searchTags:"",
      validationRules: {
        name: [(v) => !!v || 'Name is required'],
        email: [(v) => !!v || 'Type is required'],
        role: [(v) => !!v || 'Type is required'],
        skypeId: [(v) => !!v || 'Type is required'],
      },
      dialog: this.value,
      managerData: {
        id: null,
        name: '',
        email: '',
        skypeId: '',
        umbrellaRole: '',
        platformEmployeeId: '',
        platformEmployeeInfo: {},
        role: '',
        isEdit: false,
      },
    };
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('managers', ['getUmbrellaUsers']),
    isFormValid() {
      return this.managerData.email && this.managerData.role && this.managerData.status;
    },
  },
  methods: {
    ...mapActions('managers', ['saveUmbrellaUsers']),
    updateEmail() {
      const selectedUser = this.umbrellaUsersAll.find(user => user.name === this.managerData.name);
      console.log('selectedUser', selectedUser);
      if (selectedUser) {
        this.managerData.email = selectedUser.email;
        this.managerData.umbrellaRole = selectedUser.role;
        this.managerData.platformEmployeeId = selectedUser.employee_id;
      } else {
        this.managerData.email = '';
        this.managerData.umbrellaRole = '';
      }
    },
    handleCreateOrUpdateManager() {
      this.managerData.isEdit = this.isEdit;
      this.$emit('createOrUpdateAccountManager', this.managerData);
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
      this.managerData = {
        id: null,
        name: '',
        email: '',
        role: '',
        skypeId: '',
        platformEmployeeId: '',
      };
      this.$emit('close');
    },
  },
  async mounted() {
    await this.saveUmbrellaUsers();
    if (this.item) {
      this.isEdit = true;
      this.managerData.id = this.item.id;
      this.managerData.name = this.item.name;
      this.managerData.dateAdded = this.item.dateAdded;
      this.managerData.email = this.item.email;
      this.managerData.role = this.item.role;
      this.managerData.umbrellaRole = this.item.role
      this.managerData.skypeId = this.item.skypeId;
      this.managerData.status = this.item.status;
      this.managerData.platformEmployeeId = this.item.platformEmployeeId;
    }
    this.umbrellaUsersAll = this.getUmbrellaUsers
    this.umbrellaUsers = this.getUmbrellaUsers.map(user => user.name);
  },

};
</script>

<style scoped>
.image-preview {
  max-width: 100%;
  max-height: 250px;
}

.upload-area {
  //background-image: url('~@/assets/upload_file.svg'); /* Путь к SVG файлу */
  background-repeat: no-repeat;
  background-position: top;
  background-size: 50%;
  width: 400px;
  height: 200px;
  padding: 16px;
  border-radius: 8px;
  background-color: #F5F5F5;
  border: 1px dashed #CCCCCC;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: background-color 0.2s;
  cursor: pointer;
}

.upload-area:hover {
  background-color: #E9E9E9;
}

.image-preview {
  max-width: 100%;
  max-height: 150px;
  margin-top: 16px;
}

input[type="file"] {
  display: none;
}

.upload-instructions {
  font-size: 24px;
  color: #000;
  font-weight: bold;
  margin-bottom: 16px;

}
.browse-link {
  color: #FFA500;
  cursor: pointer;
}

.supported-format {
  font-size: 18px;
  color: #666;
  font-weight: 300;

}

.file-upload-details {
}
.error-message {
  color: red;
}

.file-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
  background-color: #f4f4f4;
  border: 1px solid #e1e1e1;
  padding: 0.5rem;
}
.uploaded-image-preview {
  max-width: 50px;
  max-height: 50px;
  margin-right: 1rem;
}
.file-name {
  flex-grow: 1;
}
.remove-file {
  cursor: pointer;
  color: #ff0000;
  font-weight: bold;
}

</style>
